import { getApps, getApp, initializeApp } from 'firebase/app';
import { getMessaging, getToken, isSupported } from 'firebase/messaging';

const config = {
  apiKey: process.env.REACT_APP_FIREBASE_WEB_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGE_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};
let registrationPromise;
export function registerBrowserPush() {
  if (
    !('serviceWorker' in navigator) ||
    !config.apiKey ||
    !config.projectId ||
    !config.messagingSenderId ||
    !config.appId
  ) {
    return Promise.reject(
      new Error('Browser notifications are not configured.')
    );
  }
  if (!registrationPromise) {
    // Firebase web configuration is public. Passing it explicitly avoids a
    // second, incompatible environment-substitution pipeline in public/.
    const url = `/firebase-messaging-sw.js?config=${encodeURIComponent(
      JSON.stringify(config)
    )}`;
    registrationPromise = navigator.serviceWorker
      .register(url)
      .then(
        (registration) =>
          new Promise((resolve, reject) => {
            if (registration.active) return resolve(registration);
            const worker = registration.installing || registration.waiting;
            if (!worker)
              return reject(
                new Error('Browser notifications could not start.')
              );
            const timer = setTimeout(() => {
              worker.removeEventListener('statechange', changed);
              reject(
                new Error(
                  'Browser notifications could not start. Please try again.'
                )
              );
            }, 15000);
            function changed() {
              if (
                worker.state === 'activated' ||
                worker.state === 'redundant'
              ) {
                clearTimeout(timer);
                worker.removeEventListener('statechange', changed);
                if (worker.state === 'activated') resolve(registration);
                else
                  reject(new Error('Browser notifications could not start.'));
              }
            }
            worker.addEventListener('statechange', changed);
            changed();
          })
      )
      .catch((error) => {
        registrationPromise = undefined;
        throw error;
      });
  }
  return registrationPromise;
}

// Permission must already have been granted through a user gesture.
export async function browserPushToken() {
  if (!(await isSupported()))
    throw Object.assign(
      new Error('This browser does not support web push notifications.'),
      { code: 'push/unsupported' }
    );
  if (Notification.permission !== 'granted')
    throw new Error('Enable browser notifications to subscribe.');
  if (!process.env.REACT_APP_WEB_PUSH_KEY)
    throw new Error('Browser notifications are not configured.');
  const registration = await registerBrowserPush();
  const app = getApps().length ? getApp() : initializeApp(config);
  return getToken(getMessaging(app), {
    vapidKey: process.env.REACT_APP_WEB_PUSH_KEY,
    serviceWorkerRegistration: registration,
  });
}
